/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Jayesh Shadi",
  title: "Hi, I'm Jayesh",
  subTitle: emoji(
    "A Software Developer with 3+ years of experience building scalable web applications and working closely with cross-functional teams. Comfortable with Java, JavaScript, TypeScript, Angular, and Node.js, and focused on writing clean, reliable code."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1IRRsfm6fYEAjcDjudu2FXqxYCkiJm3hd/view?usp=drive_link",
  displayGreeting: true
};

const highlightsSection = {
  title: "Highlights",
  subtitle: "Impact-driven engineering work",
  highlights: [
    "400+ APIs governed with centralized rate limiting and security",
    "20M+ daily API calls optimized using caching and middleware",
    "45% backend latency reduction in production systems",
    "Led WinForms to Angular migration with zero downtime"
  ],
  display: false
};


// Social Media Links

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/jayesh-shadi",
  linkedin: "https://www.linkedin.com/in/jayesh-shadi-02486a10a/",
  gmail: "jshadi1300@gmail.com",
  leetcode: "https://leetcode.com/jshadi1300/",
  hackerrank: "https://www.hackerrank.com/jshadi1300",
  codechef: "https://www.codechef.com/users/jayesh_1300",
  display: true
};


// Skills Section

// Skills Section
const skillsSection = {
  title: "What I do",
  subTitle: "SOFTWARE DEVELOPER EXPLORING MODERN TECH STACKS",
  skills: [
    emoji(
      "⚡ Build responsive and scalable web applications using Angular, Node.js, and .NET frameworks"
    ),
    emoji(
      "⚡ Develop RESTful APIs and integrate third-party services with applications"
    ),
    emoji("⚡ Work on cloud technologies like AWS (EC2, S3) and Azure"),
    emoji("⚡ Design and build scalable backend systems and RESTful APIs"),
    emoji("⚡ Performance optimization, caching, and rate-limiting for high-traffic systems"),
    emoji("⚡ Frontend modernization using Angular with focus on performance and UX"),
    emoji("⚡ Production debugging, monitoring, and cross-team collaboration")
  ],
  softwareSkills: [
    { skillName: "Angular", fontAwesomeClassname: "fab fa-angular" },
    { skillName: "Node.js", fontAwesomeClassname: "fab fa-node" },
    { skillName: "JavaScript", fontAwesomeClassname: "fab fa-js" },
    { skillName: "Docker", fontAwesomeClassname: "fab fa-docker" },
    { skillName: "HTML5", fontAwesomeClassname: "fab fa-html5" },
    { skillName: "CSS3", fontAwesomeClassname: "fab fa-css3-alt" },
    { skillName: "PostgreSQL", fontAwesomeClassname: "fas fa-database" }
  ],
  display: true
};
// Education Section

// Education Section
const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Vivekanand Education Society’s Institute Of Technology",
      logo: require("./assets/images/ves.jfif"),
      subHeader: "Bachelor of Engineering in Computer Engineering",
      duration: "Aug 2018 - May 2022",
      desc: "Graduated with a GPA of 8.94",
      descBullets: []
    },
    {
      schoolName: "Ideal Junior College",
      logo: require("./assets/images/ideal_junior_college.png"),
      subHeader: "High School (TSBIE BOARD)",
      duration: "July 2016 - March 2018",
      desc: "Scored 94.3%",
      descBullets: []
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

// Work Experience Section
const workExperiences = {
  display: true,
  experience: [
    {
      role: "Manager - IT (Software Developer)",
      company: "Kotak Securities",
      companylogo: require("./assets/images/kotaksec.png"),
      date: "June 2024 - Present",
      desc: "Worked on scalable applications and API development.",
      descBullets: [
        "Built an API management wrapper governing 400+ APIs, reducing response times by 30%",
        "Developed an in-house API documentation system, reducing new developer onboarding time by 40%.",
        "Optimized backend and implemented caching for 20M+ daily API calls using Node.js, Express, and .NET, reducing latency by 45%."
      ]
    },
    {
      role: "Deputy Manager - IT (Software Developer)",
      company: "Kotak Securities",
      companylogo: require("./assets/images/kotaksec.png"),
      date: "June 2022 - June 2024",
      desc: "Worked on scalable applications and API development.",
      descBullets: [
        "Led the migration of a 10-year-old JV system from WinForms to Angular v15.2.8, reducing load time by 60% and improving user task completion by 50%.",
        "Automated report generation for 4 finance departments, saving 120+ hours/month using .NET and Crystal Reports."
      ]
    },
    {
      role: "Management Trainee - IT (Software Developer)",
      company: "Kotak Securities",
      companylogo: require("./assets/images/kotaksec.png"),
      date: "June 2022 - June 2023",
      desc: "Worked on scalable applications and API development.",
      descBullets: [
        "Completed full-stack training and delivered 3 POC projects using Angular, .NET, and Node.js."
      ]
    },
    {
      role: "Web Developer Intern",
      company: "VESIT Renaissance Cell",
      companylogo: require("./assets/images/ves.jfif"),
      date: "May 2020 - July 2020",
      desc: "Developed a faculty profile management website with features to manage and publish profiles."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "TECHNOLOGIES I HAVE WORKED WITH",
  projects: [
    {
      image: require("./assets/images/chikitsak.png"),
      projectName: "Chikitsak - Disease Prediction System",
      projectDesc:
        "A machine learning-based system predicting diseases with Random Forest, achieving up to 97.6% accuracy.",
      footerLink: [
        {
          name: "Source Code",
          url: "https://github.com/jayesh-shadi/Chikitsak-Disease_Prediction_Using_Machine_Learning"
        }
      ]
    },
    {
      image: require("./assets/images/bus.jpg"),
      projectName: "Automated Crowd Management System",
      projectDesc:
        "Developed an Android app providing live crowd density updates for public transport using CNN.",
      footerLink: [
        {
          name: "Source Code",
          url: "https://github.com/jayesh-shadi/Automated-Crowd-Management-system-in-Bus"
        }
      ]
    },
    {
      image: require("./assets/images/roleBasedBlog.jpeg"),
      projectName: "",
      projectDesc:
        "Developed a Role Based Blog Application using MERN Stack with JWT Authentication and CRUD operations.",
      footerLink: [
        {
          name: "Demo",
          url: "https://rolebased-blog.vercel.app"
        }
      ]
    },
    {
      image: require("./assets/images/emireview.gif"),
      projectName: "",
      projectDesc:
        "Developed a emi calculator application using React.js.",
      footerLink: [
        {
          name: "Demo",
          url: "https://emi-calculator-lse6q2pdo-jayeshshadis-projects.vercel.app"
        }
      ]
    },
    {
      image: require("./assets/images/randomPassGenerator.png"),
      projectName: "",
      projectDesc:
        "Random Password Generator built with React.js that creates secure passwords based on user-defined criteria.",
      footerLink: [
        {
          name: "Demo",
          url: "https://random-password-generator-eight-nu.vercel.app"
        }
      ]
    }
  ],
  display: true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements & Certifications 🏆"),
  subtitle:
    "Key achievements, certifications, and recognitions from my academic and professional journey",

  achievementsCards: [
    {
      title: "Microsoft Certified: Azure Data Fundamentals",
      subtitle:
        "Earned the Microsoft Certified: Azure Data Fundamentals (DP-900) certification, demonstrating foundational knowledge in cloud data services.",
      image: require("./assets/images/azure_dp900.png"),
      imageAlt: "Azure Data Fundamentals",
      footerLink: [
        {
          name: "Certification Details",
          url: "https://www.credly.com/badges/38dd2282-a93d-4973-8524-5e253a1b46f8?source=linked_in_profile" // optional Azure certification link if available
        }
      ]
    },
    {
      title: "IT Champion – Kotak Securities",
      subtitle:
        "Awarded 'Information Technology Champion' for H2 FY 2023-24 at Kotak Securities, recognizing outstanding contribution and teamwork.",
      image: require("./assets/images/kotak_award.png"),
      imageAlt: "Kotak Securities IT Champion",
      footerLink: []
    },
    {
      title: "Research Publication – Disease Prediction System",
      subtitle:
        "Published research paper on disease prediction using Machine Learning in an ISO 9001:2008 certified journal with an impact factor of 7.529.",
      image: require("./assets/images/research.png"), // optional generic research icon
      imageAlt: "Research Publication",
      footerLink: [
        {
          name: "View Paper",
          url: "https://www.irjet.net/archives/V8/i7/IRJET-V8I7279.pdf"
        }
      ]
    },
    {
      title: "HackerRank Skill Certification",
      subtitle:
        "Verified certifications in Java and SQL, demonstrating strong programming fundamentals.",
      image: require("./assets/images/hackerrank.png"),
      imageAlt: "HackerRank Certification",
      footerLink: [
        {
          name: "View Profile",
          url: "https://www.hackerrank.com/jshadi1300"
        }
      ]
    },
    {
      title: "Techgig Code Gladiators – Semi Finalist",
      subtitle:
        "Reached the semi-finals in one of India’s largest competitive programming contests.",
      image: require("./assets/images/techgig.png"),
      imageAlt: "Techgig Code Gladiators"
    },
    {
      title: "Problem Solving & DSA",
      subtitle:
        "Solved 200+ Data Structures and Algorithms problems on LeetCode, strengthening problem-solving and algorithmic thinking.",
      image: require("./assets/images/leetcode.png"),
      imageAlt: "LeetCode Profile",
      footerLink: [
        {
          name: "LeetCode Profile",
          url: "https://leetcode.com/jshadi1300/"
        }
      ]
    }
  ],
  display: true
};


// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};


// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Let's discuss your next project or just say hi!",
  number: "+91-7620771103",
  email_address: "jshadi1300@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "jayesh_shadi", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};



const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  highlightsSection
};
